import { UniButton } from '@/design-system/components/buttons';
import { H6, TextBody, TextCaption } from '@/design-system/components/typography';
import { SxProp, View } from 'dripsy';
import _ from 'lodash';
import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@/design-system/components/icons/Icon';
import { LayoutContext } from 'contexts/LayoutContext';
import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { ChangeATMPINStackParamList } from './type';
import moment from 'moment-timezone';

export interface ChangeATMPINProps {
  onClose: () => void;
  data: any;
  onLayout: (event: any) => void;
  account: string;
  tab?: number;
  returnData?: any;
}

export const ChangeATMPINWebTwoScreen: React.FC<ChangeATMPINProps> = (props) => {
  const { onClose, data, onLayout, account, tab, returnData } = props;
  const { t } = useTranslation('account-management');
  const layout = useContext(LayoutContext);
  const {
    topHeader,
    body,
    horizontalWrapper,
    textLabel,
    textDebitAmount,
    textTitle,
    textAtmPin,
    btn,
    textHeaderTitle,
    textHeaderSubTitle,
    timeView,
    refView
  } = sxStyles;

  const showPassword = (atmPin: string) => {
    return `${atmPin.substring(0, 1)}****${atmPin.substring(atmPin.length - 1)}`;
  };

  const navigation = useNavigation<NativeStackNavigationProp<ChangeATMPINStackParamList>>();

  const [instructionTime, setInstructionTime] = useState(moment().format('YYYY-MM-DD HH:mm:ss'));

  return (
    <View
      sx={{
        height: layout.isMobile ? '100%' : 'auto',
        width: layout.dimensions.width,
        maxWidth: layout.isMobile ? layout.dimensions.width : Math.min(500, layout.dimensions.width),
        backgroundColor: '$backgroundPrimary'
      }}
      onLayout={(event) => {
        onLayout(event);
      }}>
      <View sx={topHeader}>
        <Icon name="checkCircleBlue" height={90} width={90} />
        <H6 bold sx={textHeaderTitle}>
          {t('card-account-management::change-atm-pin.title--change-atm-pin-placed')}
        </H6>
        <TextCaption sx={textHeaderSubTitle}>{t('card-account-management::change-atm-pin.text--created-new-pin')}</TextCaption>
      </View>
      <View sx={body}>
        <TextCaption sx={textTitle} semiBold>
          {t('card-account-management::change-atm-pin.text--new-atm-pin')}
        </TextCaption>
        <H6 sx={textAtmPin}>{showPassword(data.pin)}</H6>
        <View sx={{ mb: '$7' }}>
          <View
            sx={{
              ...horizontalWrapper,
              ...timeView
            }}>
            <TextBody sx={textLabel}>{t('card-account-management::lock-card.text--instruction-time')}</TextBody>
            <TextBody sx={textDebitAmount}>{returnData?.instructionTime || instructionTime || '-'}</TextBody>
          </View>
          {/* <View
          sx={{
            ...horizontalWrapper,
            ...refView
          }}>
          <TextBody sx={textLabel}>{t('card-account-management::lock-card.text--ref-id')}</TextBody>
          <TextBody sx={textDebitAmount}>{returnData?.refId || '-'}</TextBody>
        </View> */}
        </View>
        <UniButton
          sx={btn}
          labelSx={{ color: '$balck' }}
          label={t('card-account-management::general.button--close')}
          onPress={() => navigation.getParent()?.goBack()}
        />
      </View>
    </View>
  );
};

const sxStyles: Record<string, SxProp> = {
  topHeader: {
    justifyContent: 'center',
    alignItems: 'center',
    background: 'primaryDefault',
    mt: '$10'
  },
  body: {
    minHeight: 200,
    minWidth: 500,
    px: 28,
    py: 28
  },
  horizontalWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  textLabel: {
    color: '$textSecondary'
  },
  textDebitAmount: {
    mb: '$1',
    color: '$textPrimary'
  },
  textTitle: {
    marginBottom: 4,
    color: '$textSecondary'
  },
  textAtmPin: {
    fontWeight: 'bolder',
    color: '$textThemeSecondary'
  },
  btn: {
    width: '100%',
    height: 44
  },
  textHeaderTitle: {
    mb: '$2'
  },
  textHeaderSubTitle: {
    color: '$textPrimary'
  },
  timeView: {
    mb: '$3',
    mt: '$5'
  },
  refView: {
    mb: '$10'
  }
};
